<template>
  <div class="main-content main-wrap">
    <div class="center-form">
    <img :src="require('~/assets/images/icon_review.png')" width="120" height="120" />
    <p style="margin-top: 20px;
    font-size: 16px;
    line-height: 2;">您的人事账号正在审核中……<br />
    请耐心等待</p>
    </div>    
  </div>
</template>

<script>
export default {
  data(){
    return{      
    };
  },
  created(){
    this.$emit('changeMenu', '');
  }
};
</script>

<style>

</style>